import { useGroupContractProcess } from '../contexts/GroupContractProcessContext';

/**
 * Header de page pour un contrat collectif. Style aligné sur `ContractualizationHeader`
 * de la simulation : label + identifiant en pilule + infos (statut & souscripteur).
 * Pas de bouton "Détails du devis" (non applicable au contrat collectif).
 * Le contrat vient du contexte (chargé une seule fois par le provider).
 */
export const GroupContractHeader = () => {
  const { contract } = useGroupContractProcess();

  const identifier = contract?.contractIdentifier ?? '…';
  const isMaster = !!contract?.isMaster;
  const mainLabel = isMaster ? 'Contrat Cadre' : 'Contrat de Groupe';
  const subscriberName = (contract?.subscriber as { name?: string } | undefined)?.name;

  return (
    <div className="flex items-center gap-3 flex-wrap">
      <h1 className="text-2xl font-bold text-gray-900">{mainLabel}</h1>
      <div className="w-px h-8 bg-gray-300"></div>
      <div className="bg-primary/10 text-primary px-4 py-2 rounded-lg font-semibold">
        {identifier}
      </div>
      <div className="flex pl-8 space-x-8 items-center">
        {subscriberName && <SubscriberInfo subscriberName={subscriberName} />}
      </div>
    </div>
  );
};

const SubscriberInfo = ({ subscriberName }: { subscriberName: string }) => (
  <div className="flex flex-col text-sm text-slate-700">
    <div>Souscripteur</div>
    <div className="text-sm text-primary rounded-lg font-semibold">
      {subscriberName}
    </div>
  </div>
);
